/* fetalADN · interacciones globales: carruseles de catálogo y aparición sutil al hacer scroll */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function arrow(d){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+(d<0?'M15 6l-6 6 6 6':'M9 6l6 6-6 6')+'"/></svg>';}
  function rails(){
    document.querySelectorAll('.fd .fd-catalog__grid:not([data-rail])').forEach(function(g){
      g.dataset.rail=1;
      var nav=document.createElement('div');nav.className='fd-railnav';
      nav.innerHTML='<button type="button" aria-label="Anterior">'+arrow(-1)+'</button><button type="button" aria-label="Siguiente">'+arrow(1)+'</button>';
      g.parentNode.insertBefore(nav,g);
      var b=nav.querySelectorAll('button');
      function vis(){return [].filter.call(g.children,function(c){return c.offsetParent!==null;}).length;}
      function upd(){var on=vis()>4;g.classList.toggle('fd-rail',on);nav.classList.toggle('is-on',on);b[0].disabled=g.scrollLeft<4;b[1].disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-4;}
      b[0].onclick=function(){g.scrollBy({left:-g.clientWidth*0.75,behavior:'smooth'});};
      b[1].onclick=function(){g.scrollBy({left:g.clientWidth*0.75,behavior:'smooth'});};
      g.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);
      new MutationObserver(function(){g.scrollLeft=0;setTimeout(upd,30);}).observe(g,{attributes:true,subtree:true,attributeFilter:['hidden','style']});
      upd();
    });
  }
  var SEL='.fd .fd-head,.fd .fd-hero__copy,.fd .fd-split__text,.fd .fd-split__media,.fd .fd-stages__rail,.fd .fd-catalog__grid,.fd .fd-products__grid,.fd .fd-start__grid,.fd .fd-features__grid,.fd .fd-voices__grid,.fd .fd-steps__list,.fd .fd-cta__box,.fd .fd-faq,.fd .fd-lead__form,.fd .fd-divisions__grid,.fd .fd-team__grid';
  var io=null;
  function show(el){el.classList.add('fd-in');setTimeout(function(){el.removeAttribute('data-rv');el.classList.remove('fd-in');el.dataset.rvd=1;el.style.removeProperty('--fd-d');},1200);}
  function reveal(){
    if(reduce||!('IntersectionObserver' in window))return;
    if(!io){document.documentElement.classList.add('fd-anim');io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.08});}
    document.querySelectorAll(SEL).forEach(function(el){
      if(el.dataset.rv||el.dataset.rvd)return;el.dataset.rv=1;
      var sib=el.parentElement?[].indexOf.call(el.parentElement.children,el):0;
      el.style.setProperty('--fd-d',Math.min(sib,5)*70+'ms');
      var r=el.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0){el.removeAttribute('data-rv');el.dataset.rvd=1;return;}
      io.observe(el);
    });
  }

  /* Compra directa: el botón de la ficha agrega el producto y lleva al pago (Mercado Pago) */
  var BTN='product-form-component .add-to-cart-button,.sticky-add-to-cart__button';
  function buyNowLabels(){
    document.querySelectorAll(BTN).forEach(function(s){
      var w=document.createTreeWalker(s,NodeFilter.SHOW_TEXT),n;
      while(n=w.nextNode()){if(/Agregar al carrito|Añadir al carrito/i.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(/Agregar al carrito|Añadir al carrito/i,'Comprar ahora');}
    });
  }
  var buying=false;
  function buy(f,btn){
    if(buying)return;
    if(!f.checkValidity()){f.reportValidity();var bad=f.querySelector(':invalid');if(bad)bad.scrollIntoView({block:'center',behavior:'smooth'});return;}
    var fd=new FormData(f);
    document.querySelectorAll('[form="'+f.id+'"]').forEach(function(x){if(x.name&&!x.disabled&&((x.type!=='checkbox'&&x.type!=='radio')||x.checked))fd.set(x.name,x.value);});
    buying=true;btn.setAttribute('aria-busy','true');btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){if(!r.ok)throw r;return r.json();})
      .then(function(){location.href='/checkout';})
      .catch(function(){buying=false;btn.disabled=false;btn.removeAttribute('aria-busy');btn.textContent='Intenta de nuevo';});
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest(BTN);if(!btn)return;
    var f=btn.closest('form[action*="/cart/add"]')||document.querySelector('product-form-component form[action*="/cart/add"]');
    if(!f)return;
    e.preventDefault();e.stopImmediatePropagation();
    buy(f,btn);
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f||!f.matches||!f.matches('product-form-component form[action*="/cart/add"]'))return;
    e.preventDefault();e.stopImmediatePropagation();
    buy(f,f.querySelector('.add-to-cart-button')||f);
  },true);
  function footLogo(){
    var h=[].find.call(document.querySelectorAll('footer h3'),function(x){return x.textContent.trim()==='fetalADN';});
    var l=document.querySelector('header .header-logo img, header img');
    if(h&&l){var i=document.createElement('img');i.src=l.currentSrc||l.src;i.alt='fetalADN';i.className='fd-footlogo';i.width=130;i.height=40;h.replaceWith(i);}
  }
  /* Envío gratis desde $990: aviso con barra de progreso en carrito y cajón */
  var FREE=99000,fsT=null,fsBusy=false;
  function money(c){return '$'+Math.ceil(c/100).toLocaleString('es-MX');}
  function freeShip(){
    var tots=document.querySelectorAll('.cart-totals');if(!tots.length||fsBusy)return;
    fsBusy=true;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      tots.forEach(function(t){
        var box=t.parentNode.querySelector(':scope > .fd-freeship');
        if(!c.item_count){if(box)box.remove();return;}
        if(!box){box=document.createElement('div');box.className='fd-freeship';t.parentNode.insertBefore(box,t);}
        var ok=c.total_price>=FREE,pct=Math.min(100,Math.round(c.total_price/FREE*100));
        var html=ok?'<p><strong>Tu pedido tiene envío gratis</strong></p>':'<p>Te faltan <strong>'+money(FREE-c.total_price)+'</strong> para tener <strong>envío gratis</strong></p>';
        html+='<span class="fd-freeship__bar"><i style="width:'+pct+'%"></i></span>';
        if(box.innerHTML!==html)box.innerHTML=html;
        box.classList.toggle('is-ok',ok);
      });
    }).catch(function(){}).then(function(){fsBusy=false;});
  }
  function queueFS(){clearTimeout(fsT);fsT=setTimeout(freeShip,350);}
  document.addEventListener('cart:update',queueFS);
  function run(){try{rails();reveal();buyNowLabels();footLogo();queueFS();}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
  new MutationObserver(function(m){buyNowLabels();if(document.querySelector('.cart-totals')&&m.some(function(x){return x.target.closest&&x.target.closest('.cart-summary,.cart-drawer,cart-drawer-component,cart-items-component');}))queueFS();}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  setTimeout(function(){document.querySelectorAll('.fd-anim [data-rv]:not(.fd-in)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight)show(el);});},2500);
})();
